import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

// Auth0
import { AuthModule } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';

// ag-Grid
import { AgGridModule } from 'ag-grid-angular';
import { HighchartsChartModule } from 'highcharts-angular';

// Components
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { LocationsComponent } from './components/locations/locations.component';
import { NonLocationAlertsComponent } from './components/non-location-alerts/non-location-alerts.component';
import { LocationAlertsComponent } from './components/location-alerts/location-alerts.component';
import { FleetSelectorComponent } from './components/fleet-selector/fleet-selector.component';
import { FleetHealthComponent } from './components/fleet-health/fleet-health.component';
import { HubConfigurationComponent } from './components/hub-configuration/hub-configuration.component';
import { LocationPlotsComponent } from './components/location-plots/location-plots.component';
import { GooglePlacesAutocompleteComponent } from './components/google-places-autocomplete/google-places-autocomplete.component';
import { AddLocationComponent } from './components/add-location/add-location.component';
import { MoveHubComponent } from './components/move-hub/move-hub.component';
import { ChangeFleetComponent } from './components/change-fleet/change-fleet.component';
import { AddUserComponent } from './components/add-user/add-user.component';

// Services
import { AuthInterceptor } from './services/auth.interceptor';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'locations', component: LocationsComponent, canActivate: [AuthGuard] },
  { path: 'location-alerts', component: LocationAlertsComponent, canActivate: [AuthGuard] },
  { path: 'non-location-alerts', component: NonLocationAlertsComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    LoginComponent,
    LocationsComponent,
    LocationAlertsComponent,
    NonLocationAlertsComponent,
    FleetSelectorComponent,
    FleetHealthComponent,
    HubConfigurationComponent,
    LocationPlotsComponent,
    GooglePlacesAutocompleteComponent,
    AddLocationComponent,
    MoveHubComponent,
    ChangeFleetComponent,
    AddUserComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes),
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: environment.auth0.redirectUri,
        audience: environment.auth0.audience,
        connection: environment.auth0.connection
      }
    }),
    AgGridModule,
    HighchartsChartModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
